<footer class="main-footer">
  <div class="container-dynamic flex" style="padding-left: 1rem; padding-right: 1rem;">
    {{customerName}}
    <span class="m-auto"></span>
    Copyright<mat-icon class="copyright"
      style="font-size: 13px; position: relative; bottom: -7px; right: -5px">copyright</mat-icon>{{year}}, Developed
    by
    HANUMAN IT
  </div>
</footer>
